import apiSlice from "./apiSlice";
const imageGallerySlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getImageGalleryCategoryList: builder.query({
            query: (req) => ({
                url: `Settings?name=ImageCateogary`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addImageGallery: builder.mutation({
            query: (body) => ({
                url: `ImageGallary`,
                method: 'POST',
                body,
            }),
        }),
        getPendingImageGallery: builder.query({
            query: (req) => ({
                url: `ImageGallary/pending`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PendingImageGalleryTag"],
        }),
        getSubmittedImageGallery: builder.query({
            query: (req) => ({
                url: `ImageGallary/Submitted`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getAllImageGallery: builder.query({
            query: (req) => ({
                url: `ImageGallary`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        updateImageGalleryStatus: builder.mutation({
            query: (body) => ({
                url: `ImageGallary`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["PendingImageGalleryTag"]
        }),
    }),
});

export const { useUpdateImageGalleryStatusMutation, useGetImageGalleryCategoryListQuery, useAddImageGalleryMutation, useGetPendingImageGalleryQuery, useGetSubmittedImageGalleryQuery, useGetAllImageGalleryQuery } = imageGallerySlice;
